import React from 'react';
import { Controller, useForm} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { styleCollective } from '../styleService';
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { REQUIRED_MESSAGE } from '../../../constants';

const FormInitialService = ({laboratorys, onSubmitNextForm, handleClickGoBack}) => {
    const classes = styleCollective();

    const schema = yup.object().shape({
        today: yup.string().nullable().notRequired(),
        company: yup.string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, 'Ingrese mínimo 3 caracteres')
          .max(100, 'Ingrese máximo 100 caracteres')
          .matches(
            /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
            "Ingrese un nombre válido"
          ),
        laboratory: yup.string()
          .nullable()
          .required(REQUIRED_MESSAGE)
    });
      
    const { register, handleSubmit, errors, control } = useForm({
    resolver: yupResolver(schema),
    defaultValues:{
        today: new Date(),
        company: '',
        laboratory: ''
    },
    mode: "all",
    reValidateMode: "onChange"
    });

  return (
    <div>
        <form onSubmit={handleSubmit(onSubmitNextForm)}>
            <Grid container spacing={2}>

                <Grid item xs={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                            <Controller
                            as={
                                <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                variant="inline"
                                name="today"
                                className={classes.inputForm}
                                format="dd/MM/yyyy"
                                dateFormat="dd/MM/yyyy"
                                label=""
                                InputLabelProps={{ shrink: true }}
                                error={
                                    !!errors.hasOwnProperty("today") &&
                                    errors["today"].message
                                }
                                minDate={"01.01.1900"}
                                minDateMessage={"No puede ser menor a 1900"}
                                />
                            }
                            control={control}
                            name="today"
                            size="small"
                            defaultValue={new Date()}
                            disabled={true}
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={4} lg={4}>
                    <FormControl fullWidth size="small"  shrink={true} notched={true}>
                    <TextField
                        fullWidth
                        native
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        className = {classes.inputForm}
                        inputRef={register}
                        type="text"
                        label="Empresa"
                        name="company"
                        error={errors.hasOwnProperty('company') && errors['company'].message}
                    />
                    <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                        {errors.hasOwnProperty("company") && errors["company"].message}
                    </FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={4} lg={4}>
                    <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={!!errors.hasOwnProperty("laboratory") && errors["laboratory"].message}
                    >
                    <InputLabel htmlFor="outlined-select-laboratory" shrink={true}>
                        Laboratorio 
                    </InputLabel>
                    <Controller
                        fullWidth
                        control={control}
                        name="laboratory"
                        inputRef={register}
                        defaultValue=""
                        className={classes.inputForm}
                        label="Laboratorio"
                        size="small"
                        notched={true}
                        inputProps={{
                        name: "laboratory",
                        id: "outlined-select-laboratory",
                        }}
                        as={
                        <Select>
                            {laboratorys?.map((res) => (
                            <MenuItem
                                key={res?.id}
                                value={res?.id}
                                className={classes.menuItem}
                            >
                                {res.laboratoryName}
                            </MenuItem>
                            ))}
                        </Select>
                        }
                    />
                    <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                        {errors.hasOwnProperty("laboratory") && errors["laboratory"].message}
                    </FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <Button
                        variant='outlined'
                        style={{backgroundColor: 'transparent', color: '#7EBDCE'}}
                        onClick={handleClickGoBack}
                    >
                        Cancelar
                    </Button>
                    &nbsp;&nbsp;
                    <Button 
                        variant='outlined' 
                        type="submit" 
                        style = {{backgroundColor: '#7EBDCE', border: 'none', color: '#ffffff',}} 
                    > 
                        Continuar
                    </Button >
                </Grid>
            </Grid>
        </form>
    </div>
  )
}

export default FormInitialService